import { humanized } from './locales';
import getCurrentLanguageKey from '../getCurrentLanguageKey';

import calculateTimeDifference from './calculateTimeDifference';

const humanize = (date: string | Date, lang?: 'es' | 'pt') => {
  const langKey = lang || getCurrentLanguageKey();

  return calculateTimeDifference(date, humanized[langKey]);
};

export default humanize;
